import {
  exceedsMaxDaysRange,
  getDateXDaysAfter,
  getDateXDaysBefore,
  getTodaysDate,
  isAfterDay,
  isBeforeDay,
  isSameOrAfterDay,
  isSameOrBeforeDay,
  isValid,
} from '../services/date'

import {DateRange, DateRangeConfig} from '../types'

export const getUpdatedDateRangeByFrom = (
  maxDaysRange: number,
  to: string,
  newFromDate?: string
) => {
  let newDateRange = null
  if (newFromDate && isValid(newFromDate)) {
    const isAfterTo = isAfterDay(new Date(newFromDate), to)
    const exceedsValidRange = exceedsMaxDaysRange(new Date(newFromDate), to, maxDaysRange)

    if (isAfterTo) {
      newDateRange = {from: newFromDate, to: newFromDate}
    } else if (exceedsValidRange) {
      newDateRange = {
        from: newFromDate,
        to: getDateXDaysAfter(new Date(newFromDate), maxDaysRange),
      }
    } else {
      newDateRange = {from: newFromDate, to}
    }
  }
  return newDateRange
}

export const getUpdatedDateRangeByTo = (maxDaysRange: number, from: string, newToDate?: string) => {
  let newDateRange = null
  if (newToDate && isValid(newToDate)) {
    const isBeforeFrom = isBeforeDay(new Date(newToDate), from)
    const exceedsValidRange = exceedsMaxDaysRange(from, new Date(newToDate), maxDaysRange)

    if (isBeforeFrom) {
      newDateRange = {from: newToDate, to: newToDate}
    } else if (exceedsValidRange) {
      newDateRange = {
        from: getDateXDaysBefore(new Date(newToDate), maxDaysRange),
        to: newToDate,
      }
    } else {
      newDateRange = {from, to: newToDate}
    }
  }
  return newDateRange
}

export const isDateRangeValid = (
  dateRange: DateRange,
  config: DateRangeConfig,
  minDate?: string
) => {
  const fromIsSameOrBeforeTo = isSameOrBeforeDay(dateRange.from, dateRange.to)
  const toIsSameOrAfterfrom = isSameOrAfterDay(dateRange.to, dateRange.from)
  const toIsSameOrBeforeToday = isSameOrBeforeDay(dateRange.to, getTodaysDate())
  const exceedsValidRange = exceedsMaxDaysRange(dateRange.from, dateRange.to, config.maxDaysRange)
  const exceedsEarliestFromToday = config.earliestFromTodayDays
    ? exceedsMaxDaysRange(dateRange.from, dateRange.to, config.earliestFromTodayDays)
    : false

  const isBeforeMinDate = !!minDate && isBeforeDay(dateRange.from, minDate)

  return (
    fromIsSameOrBeforeTo &&
    toIsSameOrAfterfrom &&
    toIsSameOrBeforeToday &&
    !exceedsValidRange &&
    !exceedsEarliestFromToday &&
    !isBeforeMinDate
  )
}
